import type { ReactNode } from "react";
import { useFeatureFlag } from "./useFeatureFlag";
import type { DeliveryFlagKey } from "./constants";

interface FeatureGateProps {
  readonly flag: DeliveryFlagKey;
  readonly fallback?: ReactNode;
  readonly children: ReactNode;
}

/**
 * Declarative feature gate. Renders children only if the flag evaluates to true.
 * Optional fallback rendered when flag is off.
 */
export function FeatureGate({
  flag,
  fallback = null,
  children,
}: FeatureGateProps): ReactNode {
  const isEnabled = useFeatureFlag(flag);

  if (!isEnabled) return fallback;
  return children;
}
